var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Shape } from 'lincd/shapes/Shape';
import { linkedShape } from '../package.js';
import { sioc } from '../ontologies/sioc.js';
import { UserAccount } from './UserAccount.js';
import { Space } from './Space.js';
let Usergroup = class Usergroup extends Shape {
    get members() {
        return this.getAllAs(sioc.has_member, UserAccount);
    }
    get spaces() {
        return this.getAllAs(sioc.usergroup_of, Space);
    }
};
Usergroup.targetClass = sioc.Usergroup;
Usergroup = __decorate([
    linkedShape
], Usergroup);
export { Usergroup };
//# sourceMappingURL=Usergroup.js.map